import * as React from 'react'
export const BREACH_ERROR: React.ReactElement<'span'> = (
  <span>
    Sorry, that password is not strong enough, and may have been used on other
    systems. Please create a new, more secure password.{' '}
    <a
      rel="noopener noreferrer"
      target="_blank"
      href="https://support.disco.ac/home/q-how-do-i-choose-a-secure-password"
    >
      Find out more.
    </a>
  </span>
)
